/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IDobbiesOrderLookup contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum orderStatusLookUpParametersType {
    email = 'email',
    none = 'none'
}

export interface IDobbiesOrderLookupConfig extends Msdyn365.IModuleConfig {
    paragraph?: Msdyn365.RichText;
    heading?: IHeadingData;
    orderStatusLookUpParametersType?: orderStatusLookUpParametersType;
    orderLookupSearchAdditionalFields?: IOrderLookupSearchAdditionalFieldsData[];
    clientRender?: boolean;
}

export interface IDobbiesOrderLookupResources {
    orderLookupDefaultHeadingText: string;
    orderLookupRegisteredUserText: string;
    orderLookupSignInLinkText: string;
    orderLookupViewAccountText: string;
    orderLookupButtonLabel: string;
    orderLookupFormAriaLabel: string;
    orderLookupOrderNumberLabel: string;
    orderLookupOrderNumberAriaLabel: string;
    orderLookupEmailLabel: string;
    orderLookupEmailAriaLabel: string;
    orderLookupEmailValidationErrorMessage: string;
    orderLookupOrderNumberValidationErrorMessage: string;
    orderLookupFieldValidationErrorMessage: string;
    orderLookupSubmitAriaLabel: string;
    orderLookupRequiredTextErrorMessage: string;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export interface IOrderLookupSearchAdditionalFieldsData {
    fieldKey?: string;
    labelName?: string;
    ariaLabel?: string;
    validationMessage?: string;
}

export interface IDobbiesOrderLookupProps<T> extends Msdyn365.IModule<T> {
    resources: IDobbiesOrderLookupResources;
    config: IDobbiesOrderLookupConfig;
}
